const GiftCertificateControls = ({ step, setStep }) => {
  return (
    <div className="gift-certificate-step-controls">
      <button className="button-big-primary-wide muted" onClick={() => setStep(step - 1)}><div className="util-arrow-left" /> Вернуться</button>
      <button className="button-big-primary-wide" onClick={() => setStep(step + 1)}>Следующий шаг</button>
    </div>
  )
}

export default GiftCertificateControls